import client from '@libs/HttpClient';

class HrScoringService {
  //HR Scoring Master
  static listHrScoring(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const selectedParameter = request.queryKey[3];
    const selectedMainTab = (request.queryKey[4] != '' && request.queryKey[4] != null) ? request.queryKey[4] : 'own';
    const selectedMinScore = request.queryKey[5];
    const selectedMaxScore = request.queryKey[6];
    const selectedEmployee = request.queryKey[7];
  
    return client.get(
      `/hr-scoring?search=${searchText}&page=${page_no}&selectedParameter=${selectedParameter}&selectedEmployee=${selectedEmployee}&selectedMainTab=${selectedMainTab}&selectedMinScore=${selectedMinScore}&selectedMaxScore=${selectedMaxScore}`,
      request
    );
  }
  static addHrScoring(request) {
    return client.post(`/hr-scoring`, request);
  }
  static getHrScoringEmployeeList({ hr_id }) {
    return client.get(`/hr-scoring/all-employees`, {
      params: { hr_id }   // ✅ send hr_id as query param
    });
  }
  static getHrScoringHrList(request) {
    return client.get(`/hr-scoring/all-hrs`, request);
  }
  static getParameterList(request) {
    return client.get(`/hr-scoring/all-parameters`, request);
  }
  static viewHrScoring({ selectedEditId, selectedUserHrScoreDetailId }) {
    return client.get(`/hr-scoring/${selectedEditId}/edit`, {
      params: selectedUserHrScoreDetailId ? { user_hr_scores_detail_id: selectedUserHrScoreDetailId } : {},
    });
  }
  static updateHrScoring(request) {
    return client.put(`/hr-scoring/${request.user_hr_score_id}`, request);
  }
  static deleteHrScoring(request) {
    return client.delete(`/hr-scoring/${request.id}`, request);
  }
  static showHrScoring(params) {
    return client.get(`/hr-scoring/${params}`);
  }
  static getTeamAccessORNot(request) {
    return client.get(
      `/hr-scoring/is-team-tab-show`,
      request
    );
  }
}
export { HrScoringService };
